import { Building, Floor, Room, RoomType } from '../../types';

// Mock data for School Structure page
// ~50 rooms across 3-4 floors in main building

export const mockBuildings: Building[] = [
  {
    id: 'building-main',
    schoolId: 'school-demo',
    name: 'Main Building',
    code: 'MAIN',
    floors: [],
  },
  {
    id: 'building-science',
    schoolId: 'school-demo',
    name: 'Science Block',
    code: 'SCI',
    floors: [],
  },
  {
    id: 'building-sports',
    schoolId: 'school-demo',
    name: 'Sports Centre',
    code: 'SPORTS',
    floors: [],
  },
];

export const mockFloors: Floor[] = [
  // Main Building Floors
  {
    id: 'floor-main-g',
    buildingId: 'building-main',
    name: 'Ground Floor',
    level: 0,
    rooms: [],
  },
  {
    id: 'floor-main-1',
    buildingId: 'building-main',
    name: 'First Floor',
    level: 1,
    rooms: [],
  },
  {
    id: 'floor-main-2',
    buildingId: 'building-main',
    name: 'Second Floor',
    level: 2,
    rooms: [],
  },
  {
    id: 'floor-main-3',
    buildingId: 'building-main',
    name: 'Third Floor',
    level: 3,
    rooms: [],
  },
  // Science Block Floors
  {
    id: 'floor-sci-g',
    buildingId: 'building-science',
    name: 'Ground Floor',
    level: 0,
    rooms: [],
  },
  {
    id: 'floor-sci-1',
    buildingId: 'building-science',
    name: 'First Floor',
    level: 1,
    rooms: [],
  },
  // Sports Centre
  {
    id: 'floor-sports-g',
    buildingId: 'building-sports',
    name: 'Ground Floor',
    level: 0,
    rooms: [],
  },
];

export const mockRooms: Room[] = [
  // Main Building - Ground Floor (12 rooms)
  {
    id: 'room-m-g-01',
    floorId: 'floor-main-g',
    name: 'Reception',
    roomNumber: 'M-G-01',
    roomType: 'office',
    capacity: 0,
    resources: [{ id: 'res-phone', name: 'Phone', type: 'communication', quantity: 2 }],
    accessibility: 'wheelchair',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-02',
    floorId: 'floor-main-g',
    name: 'Main Hall',
    roomNumber: 'M-G-02',
    roomType: 'hall',
    capacity: 300,
    resources: [
      { id: 'res-stage', name: 'Stage', type: 'furniture', quantity: 1 },
      { id: 'res-audio', name: 'Audio System', type: 'av', quantity: 1 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-03',
    floorId: 'floor-main-g',
    name: 'Library',
    roomNumber: 'M-G-03',
    roomType: 'library',
    capacity: 60,
    resources: [
      { id: 'res-computers', name: 'Computers', type: 'ict', quantity: 20 },
      { id: 'res-printer', name: 'Printer', type: 'ict', quantity: 2 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-04',
    floorId: 'floor-main-g',
    name: 'Classroom 1',
    roomNumber: 'M-G-04',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-05',
    floorId: 'floor-main-g',
    name: 'Classroom 2',
    roomNumber: 'M-G-05',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-06',
    floorId: 'floor-main-g',
    name: 'Art Studio 1',
    roomNumber: 'M-G-06',
    roomType: 'specialist',
    capacity: 25,
    resources: [
      { id: 'res-sink', name: 'Sink', type: 'specialist', quantity: 4 },
      { id: 'res-easels', name: 'Easels', type: 'specialist', quantity: 25 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-g-07',
    floorId: 'floor-main-g',
    name: 'Music Room 1',
    roomNumber: 'M-G-07',
    roomType: 'specialist',
    capacity: 20,
    resources: [
      { id: 'res-piano', name: 'Piano', type: 'specialist', quantity: 1 },
      { id: 'res-music-stands', name: 'Music Stands', type: 'specialist', quantity: 20 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-g-08',
    floorId: 'floor-main-g',
    name: 'Canteen',
    roomNumber: 'M-G-08',
    roomType: 'dining',
    capacity: 250,
    resources: [],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-09',
    floorId: 'floor-main-g',
    name: 'Kitchen',
    roomNumber: 'M-G-09',
    roomType: 'specialist',
    capacity: 0,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-10',
    floorId: 'floor-main-g',
    name: 'Staff Room',
    roomNumber: 'M-G-10',
    roomType: 'office',
    capacity: 40,
    resources: [
      { id: 'res-coffee', name: 'Coffee Machine', type: 'furniture', quantity: 1 },
      { id: 'res-fridge', name: 'Fridge', type: 'furniture', quantity: 1 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-11',
    floorId: 'floor-main-g',
    name: 'Meeting Room',
    roomNumber: 'M-G-11',
    roomType: 'office',
    capacity: 12,
    resources: [{ id: 'res-screen', name: 'Display Screen', type: 'av', quantity: 1 }],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-g-12',
    floorId: 'floor-main-g',
    name: 'First Aid Room',
    roomNumber: 'M-G-12',
    roomType: 'medical',
    capacity: 4,
    resources: [],
    accessibility: 'wheelchair',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },

  // Main Building - First Floor (14 rooms)
  {
    id: 'room-m-1-01',
    floorId: 'floor-main-1',
    name: 'Classroom 3',
    roomNumber: 'M-1-01',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-02',
    floorId: 'floor-main-1',
    name: 'Classroom 4',
    roomNumber: 'M-1-02',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-03',
    floorId: 'floor-main-1',
    name: 'Classroom 5',
    roomNumber: 'M-1-03',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-04',
    floorId: 'floor-main-1',
    name: 'Classroom 6',
    roomNumber: 'M-1-04',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-05',
    floorId: 'floor-main-1',
    name: 'ICT Suite 1',
    roomNumber: 'M-1-05',
    roomType: 'ict',
    capacity: 30,
    resources: [
      { id: 'res-computers', name: 'Computers', type: 'ict', quantity: 30 },
      { id: 'res-printer', name: 'Printer', type: 'ict', quantity: 1 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-06',
    floorId: 'floor-main-1',
    name: 'ICT Suite 2',
    roomNumber: 'M-1-06',
    roomType: 'ict',
    capacity: 30,
    resources: [
      { id: 'res-computers', name: 'Computers', type: 'ict', quantity: 30 },
      { id: 'res-printer', name: 'Printer', type: 'ict', quantity: 1 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-07',
    floorId: 'floor-main-1',
    name: 'Drama Studio',
    roomNumber: 'M-1-07',
    roomType: 'specialist',
    capacity: 30,
    resources: [
      { id: 'res-lighting', name: 'Stage Lighting', type: 'av', quantity: 1 },
      { id: 'res-sound', name: 'Sound System', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-1-08',
    floorId: 'floor-main-1',
    name: 'Geography Room',
    roomNumber: 'M-1-08',
    roomType: 'specialist',
    capacity: 30,
    resources: [
      { id: 'res-maps', name: 'Maps', type: 'specialist', quantity: 20 },
      { id: 'res-globes', name: 'Globes', type: 'specialist', quantity: 5 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-1-09',
    floorId: 'floor-main-1',
    name: 'History Room',
    roomNumber: 'M-1-09',
    roomType: 'specialist',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-1-10',
    floorId: 'floor-main-1',
    name: 'English Room 1',
    roomNumber: 'M-1-10',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-11',
    floorId: 'floor-main-1',
    name: 'English Room 2',
    roomNumber: 'M-1-11',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-12',
    floorId: 'floor-main-1',
    name: 'English Room 3',
    roomNumber: 'M-1-12',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-13',
    floorId: 'floor-main-1',
    name: 'Storage Room',
    roomNumber: 'M-1-13',
    roomType: 'storage',
    capacity: 0,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-1-14',
    floorId: 'floor-main-1',
    name: 'Staff Office 1',
    roomNumber: 'M-1-14',
    roomType: 'office',
    capacity: 6,
    resources: [{ id: 'res-desks', name: 'Desks', type: 'furniture', quantity: 6 }],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },

  // Main Building - Second Floor (12 rooms)
  {
    id: 'room-m-2-01',
    floorId: 'floor-main-2',
    name: 'Maths Room 1',
    roomNumber: 'M-2-01',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-02',
    floorId: 'floor-main-2',
    name: 'Maths Room 2',
    roomNumber: 'M-2-02',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-03',
    floorId: 'floor-main-2',
    name: 'Maths Room 3',
    roomNumber: 'M-2-03',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-04',
    floorId: 'floor-main-2',
    name: 'Maths Room 4',
    roomNumber: 'M-2-04',
    roomType: 'classroom',
    capacity: 30,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-05',
    floorId: 'floor-main-2',
    name: 'Languages Room 1',
    roomNumber: 'M-2-05',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-audio', name: 'Audio Equipment', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-06',
    floorId: 'floor-main-2',
    name: 'Languages Room 2',
    roomNumber: 'M-2-06',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-audio', name: 'Audio Equipment', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-07',
    floorId: 'floor-main-2',
    name: 'Languages Room 3',
    roomNumber: 'M-2-07',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-audio', name: 'Audio Equipment', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-08',
    floorId: 'floor-main-2',
    name: 'RE Room',
    roomNumber: 'M-2-08',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-m-2-09',
    floorId: 'floor-main-2',
    name: 'PSHE Room',
    roomNumber: 'M-2-09',
    roomType: 'classroom',
    capacity: 28,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-2-10',
    floorId: 'floor-main-2',
    name: 'Sixth Form Study Area',
    roomNumber: 'M-2-10',
    roomType: 'study',
    capacity: 40,
    resources: [
      { id: 'res-computers', name: 'Computers', type: 'ict', quantity: 10 },
      { id: 'res-printer', name: 'Printer', type: 'ict', quantity: 1 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-2-11',
    floorId: 'floor-main-2',
    name: 'Storage Room',
    roomNumber: 'M-2-11',
    roomType: 'storage',
    capacity: 0,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-2-12',
    floorId: 'floor-main-2',
    name: 'Staff Office 2',
    roomNumber: 'M-2-12',
    roomType: 'office',
    capacity: 8,
    resources: [{ id: 'res-desks', name: 'Desks', type: 'furniture', quantity: 8 }],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },

  // Main Building - Third Floor (6 rooms)
  {
    id: 'room-m-3-01',
    floorId: 'floor-main-3',
    name: 'Classroom 7',
    roomNumber: 'M-3-01',
    roomType: 'classroom',
    capacity: 25,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'limited',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-3-02',
    floorId: 'floor-main-3',
    name: 'Classroom 8',
    roomNumber: 'M-3-02',
    roomType: 'classroom',
    capacity: 25,
    resources: [
      { id: 'res-wb', name: 'Whiteboard', type: 'teaching', quantity: 1 },
      { id: 'res-projector', name: 'Projector', type: 'av', quantity: 1 },
    ],
    accessibility: 'limited',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-3-03',
    floorId: 'floor-main-3',
    name: 'Server Room',
    roomNumber: 'M-3-03',
    roomType: 'ict',
    capacity: 0,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-3-04',
    floorId: 'floor-main-3',
    name: 'SLT Office',
    roomNumber: 'M-3-04',
    roomType: 'office',
    capacity: 10,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-3-05',
    floorId: 'floor-main-3',
    name: 'Head Teacher Office',
    roomNumber: 'M-3-05',
    roomType: 'office',
    capacity: 4,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-m-3-06',
    floorId: 'floor-main-3',
    name: 'Storage Room',
    roomNumber: 'M-3-06',
    roomType: 'storage',
    capacity: 0,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },

  // Science Block - Ground Floor (4 rooms)
  {
    id: 'room-s-g-01',
    floorId: 'floor-sci-g',
    name: 'Biology Lab 1',
    roomNumber: 'S-G-01',
    roomType: 'laboratory',
    capacity: 28,
    resources: [
      { id: 'res-microscopes', name: 'Microscopes', type: 'specialist', quantity: 14 },
      { id: 'res-fume-hood', name: 'Fume Hood', type: 'specialist', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-s-g-02',
    floorId: 'floor-sci-g',
    name: 'Biology Lab 2',
    roomNumber: 'S-G-02',
    roomType: 'laboratory',
    capacity: 28,
    resources: [
      { id: 'res-microscopes', name: 'Microscopes', type: 'specialist', quantity: 14 },
      { id: 'res-fume-hood', name: 'Fume Hood', type: 'specialist', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-s-g-03',
    floorId: 'floor-sci-g',
    name: 'Prep Room',
    roomNumber: 'S-G-03',
    roomType: 'storage',
    capacity: 0,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-s-g-04',
    floorId: 'floor-sci-g',
    name: 'Science Office',
    roomNumber: 'S-G-04',
    roomType: 'office',
    capacity: 4,
    resources: [],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },

  // Science Block - First Floor (4 rooms)
  {
    id: 'room-s-1-01',
    floorId: 'floor-sci-1',
    name: 'Chemistry Lab 1',
    roomNumber: 'S-1-01',
    roomType: 'laboratory',
    capacity: 28,
    resources: [
      { id: 'res-fume-hood', name: 'Fume Hood', type: 'specialist', quantity: 2 },
      { id: 'res-gas-taps', name: 'Gas Taps', type: 'specialist', quantity: 14 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-s-1-02',
    floorId: 'floor-sci-1',
    name: 'Chemistry Lab 2',
    roomNumber: 'S-1-02',
    roomType: 'laboratory',
    capacity: 28,
    resources: [
      { id: 'res-fume-hood', name: 'Fume Hood', type: 'specialist', quantity: 2 },
      { id: 'res-gas-taps', name: 'Gas Taps', type: 'specialist', quantity: 14 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-s-1-03',
    floorId: 'floor-sci-1',
    name: 'Physics Lab',
    roomNumber: 'S-1-03',
    roomType: 'laboratory',
    capacity: 28,
    resources: [
      { id: 'res-power', name: 'Power Supplies', type: 'specialist', quantity: 14 },
      { id: 'res-equipment', name: 'Physics Equipment', type: 'specialist', quantity: 1 },
    ],
    accessibility: 'standard',
    usage: { isShared: false, hasFixedTeacher: true, isNomadic: false },
  },
  {
    id: 'room-s-1-04',
    floorId: 'floor-sci-1',
    name: 'Prep Room',
    roomNumber: 'S-1-04',
    roomType: 'storage',
    capacity: 0,
    resources: [],
    accessibility: 'limited',
    usage: { isShared: false, hasFixedTeacher: false, isNomadic: false },
  },

  // Sports Centre - Ground Floor (4 rooms)
  {
    id: 'room-sp-g-01',
    floorId: 'floor-sports-g',
    name: 'Sports Hall',
    roomNumber: 'SP-G-01',
    roomType: 'sports',
    capacity: 60,
    resources: [
      { id: 'res-basketball', name: 'Basketball Hoops', type: 'sports', quantity: 2 },
      { id: 'res-volleyball', name: 'Volleyball Net', type: 'sports', quantity: 1 },
    ],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-sp-g-02',
    floorId: 'floor-sports-g',
    name: 'Gym',
    roomNumber: 'SP-G-02',
    roomType: 'sports',
    capacity: 30,
    resources: [{ id: 'res-equipment', name: 'Gym Equipment', type: 'sports', quantity: 20 }],
    accessibility: 'standard',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-sp-g-03',
    floorId: 'floor-sports-g',
    name: 'Changing Room 1',
    roomNumber: 'SP-G-03',
    roomType: 'changing',
    capacity: 40,
    resources: [{ id: 'res-lockers', name: 'Lockers', type: 'furniture', quantity: 40 }],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
  {
    id: 'room-sp-g-04',
    floorId: 'floor-sports-g',
    name: 'Changing Room 2',
    roomNumber: 'SP-G-04',
    roomType: 'changing',
    capacity: 40,
    resources: [{ id: 'res-lockers', name: 'Lockers', type: 'furniture', quantity: 40 }],
    accessibility: 'wheelchair',
    usage: { isShared: true, hasFixedTeacher: false, isNomadic: false },
  },
];

// Link floors to buildings
mockBuildings[0].floors = ['floor-main-g', 'floor-main-1', 'floor-main-2', 'floor-main-3'];
mockBuildings[1].floors = ['floor-sci-g', 'floor-sci-1'];
mockBuildings[2].floors = ['floor-sports-g'];

// Link rooms to floors
mockFloors[0].rooms = mockRooms.filter((r) => r.floorId === 'floor-main-g').map((r) => r.id);
mockFloors[1].rooms = mockRooms.filter((r) => r.floorId === 'floor-main-1').map((r) => r.id);
mockFloors[2].rooms = mockRooms.filter((r) => r.floorId === 'floor-main-2').map((r) => r.id);
mockFloors[3].rooms = mockRooms.filter((r) => r.floorId === 'floor-main-3').map((r) => r.id);
mockFloors[4].rooms = mockRooms.filter((r) => r.floorId === 'floor-sci-g').map((r) => r.id);
mockFloors[5].rooms = mockRooms.filter((r) => r.floorId === 'floor-sci-1').map((r) => r.id);
mockFloors[6].rooms = mockRooms.filter((r) => r.floorId === 'floor-sports-g').map((r) => r.id);

export const mockSchoolStructure = {
  buildings: mockBuildings,
  floors: mockFloors,
  rooms: mockRooms,
};
